import React, { useEffect, useRef, useState } from 'react';
import Hls from 'hls.js';
import Header from '../components/Header';
import { useLocation } from 'react-router-dom';
import MobileNav from '../components/MobileNav';
import { Radio } from 'lucide-react';
import { useNavigate } from 'react-router-dom';


export default function SingleLive() {
    const location = useLocation();
    const navigate = useNavigate();


    const videoRef = useRef(null);

    const { tvChannels, channel } = location.state || {};
    const [isFav, setIsFav] = useState(false);

    const video = channel;
    const url = video?.ChannelURL;

    useEffect(() => {
        let hls;

        if (url && videoRef.current) {
            if (Hls.isSupported()) {
                hls = new Hls();
                hls.loadSource(url);
                hls.attachMedia(videoRef.current);
                hls.on(Hls.Events.MANIFEST_PARSED, () => {
                    videoRef.current?.play().catch((err) => {
                        console.warn('Autoplay failed:', err);
                    });
                });
            } else if (videoRef.current.canPlayType('application/vnd.apple.mpegurl')) {
                videoRef.current.src = url;
                videoRef.current.play().catch((err) => {
                    console.warn('Autoplay fallback failed:', err);
                });
            }
        }

        return () => {
            if (hls) {
                hls.destroy();
            }
        };
    }, [url]);

    return (
        <>
            <Header />

            <section className='container' style={{ marginBottom: '7rem' }}>
                <div className='row'>
                    <div className='col-lg-8'>
                        <h3 className='text-light'>{channel.ChannelName}</h3>

                        <div className='mb-4'>

                            {!url ? (
                                <div className='position-relative'>
                                    <img
                                        src={video?.Thumbnail}
                                        alt="Thumbnail"
                                        width="100%"
                                        style={{
                                            aspectRatio: '2/1',
                                            objectFit: 'cover',
                                            filter: 'blur(1px) brightness(0.7)'
                                        }}
                                    />
                                    <div className="position-absolute top-50 start-50 translate-middle text-light text-center">
                                        <div className="spinner-border text-light mb-2" role="status" />
                                        <div>Loading video...</div>
                                    </div>
                                </div>
                            ) : (
                                <div style={{position:'relative'}} >
                                    <video
                                        ref={videoRef}
                                        controls
                                        muted
                                        autoPlay
                                        width="100%"
                                        style={{
                                            aspectRatio: '2/1',
                                            objectFit: 'cover',
                                            background: 'black'
                                        }}
                                    />
                                    <span className="badge bg-danger live-glow"> <Radio size={16} className="me-1" />LIVE</span>

                                </div>


                            )}

                        </div>
                    </div>

                    <div className='col-lg-4'>
                        <h3 className='text-light'>Other Channels</h3>
                        <div className='scrollableDiv'>
                            {tvChannels?.map((vid, index) => (
                                <img
                                    onClick={() => navigate("/live", { state: { tvChannels, channel: vid } })}
                                    src={vid.ChannelThumbnail}
                                    key={index}
                                    alt="channel-thumb"
                                    width="100%"
                                    className='mb-3' style={{ cursor: 'pointer', maxWidth: '200px' }}
                                />
                            ))}
                        </div>

                    </div>
                </div>
            </section>

            <MobileNav />
        </>
    );
}
